import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useTypedSelector } from '@redux/Hooks/storeSelectors';
import { selectMapLayerIdByEntityName } from '@redux/selectors/selectors';
import EntityManagerCleaner from '../entities/EntityManagerCleaner';
import EntityEditor from '../entities/EntityEditor';
import { ScenarioEventsEntityName } from '@api/types/types';

const EmissionEventEdit = () => {
    const entityName = ScenarioEventsEntityName.EmissionEvent;
    const { emissionEventId } = useParams<any>();
    const emissionsLayerId = useTypedSelector(state =>
        selectMapLayerIdByEntityName(state, entityName)
    );

    const onSaveFn = useCallback(
        (entity: any) => {
            if (!emissionEventId) {
                return `../${entity.id}/edit`;
            }
        },
        [emissionEventId]
    );

    const onDeleteFn = useCallback(() => '../../', []);

    return (
        <EntityManagerCleaner entityName={entityName}>
            <EntityEditor
                entityId={emissionEventId!}
                entityName={entityName}
                layerId={emissionsLayerId}
                presetProperty={'scenarioCasePreset'}
                getUrlOnSaveFn={onSaveFn}
                getUrlOnDeleteFn={onDeleteFn}
                showDeleteBtn={!!emissionEventId}
            />
        </EntityManagerCleaner>
    );
};

export default EmissionEventEdit;
